import React, { useState } from 'react';
import {
    Button,
    Typography,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Autocomplete,
    Grid,
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
  } from '@mui/material';
import { PropaneSharp } from '@mui/icons-material';

const ProductList = ({ selectedProductList, setSelectedProductList, productOptions, productSaved, orderType }) => {
  const [selectedProduct, setSelectedProduct] = useState('');
  const [productQuantity, setProductQuantity] = useState("1");


  const handleProductChange = (event) => {
    setSelectedProduct(event.target.value);
  };

  const handleProductQuantityChange = (event, index) => {
    const updatedProducts = [...selectedProductList];

    if (orderType.value === 'delivery_fulfillment') {
      const product_changing = productOptions.find((product) => product.sku === updatedProducts[index].sku);
      if (event.target.value > product_changing.ideal_stock) {
        updatedProducts[index].quantity = product_changing.ideal_stock;
      } else {
        updatedProducts[index].quantity = event.target.value;
      }

    } else {
      updatedProducts[index].quantity = event.target.value;
    }

    if (event.target.value < 1 && event.target.value === '') {
      updatedProducts[index].quantity = event.target.value;
    }
    else if (event.target.value < 1) {
      updatedProducts[index].quantity = 1;
    }

    setSelectedProductList(updatedProducts);
  };

  const isProductAlreadyAdded = (productSku) => {
    return selectedProductList.some((product) => product.sku === productSku);
  };

  const handleAddProduct = () => {
    if (selectedProduct !== '') {
      const selectedProductDetails = productOptions.find((product) => product.sku === selectedProduct.sku);
      if (selectedProductDetails === undefined) {
        return;
      }
      const newProduct = {
        name: selectedProductDetails.name,
        quantity: productQuantity,
        sku: selectedProductDetails.sku,
        price: selectedProductDetails.price,
      };
      
      if (!isProductAlreadyAdded(newProduct.sku)) {
        setSelectedProductList([...selectedProductList, newProduct]);
        setSelectedProduct('');
        setProductQuantity("1");
      } else {
        // Show a message or perform an action to indicate that the product already exists
        console.log('¡El producto ya ha sido agregado!');
      }
    }
  };

  const handleDeleteProduct = (index) => {
    const updatedProducts = [...selectedProductList];
    updatedProducts.splice(index, 1);
    setSelectedProductList(updatedProducts);

  };

  return (
    <div>
      { !productSaved ? (
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={6}>
          <Autocomplete
            fullWidth
            id="product-select"
            options={productOptions}
            getOptionLabel={(product) => product ? (product.sku + " - " + product.name): ""}
            renderInput={(params) => 
                <TextField 
                {...params} 
                label={productOptions.length === 0 ? "Compañía no tiene productos" : "Selecciona un Producto"} 
                disabled={productOptions.length === 0}
                />
            }
            value={selectedProduct}
            onChange={(event, newValue) => setSelectedProduct(newValue)}
            disabled={productSaved}
            />
        </Grid>
        <Grid item xs={6}>
          {/* disable button, change style when selectedProducts */}
          <Button variant="outlined" color="primary" onClick={handleAddProduct} className="add-product-button" disabled={productSaved}>
            Añadir Producto
          </Button>
        </Grid>
      </Grid>
      ) : (
        null
      )}
      <div>
        {selectedProductList.length > 0 ? (
          <div className='product-list-container'>
            <List dense>
              {selectedProductList.map((product, index) => (
                <ListItem key={index}>
                  <ListItemText primary={product.name} secondary={`SKU: ${product.sku} | Precio: ${product.price}`} />
                  <ListItemSecondaryAction>
                    <TextField
                        label="Cantidad"
                        type="number"
                        value={product.quantity}
                        onChange={(event) => handleProductQuantityChange(event, index)}
                        inputProps={{
                            min: 1,
                            step: 1,
                            max: orderType.value === 'delivery_fulfillment' ? productOptions.find((product) => product.sku === product.sku).ideal_stock : null,
                        }}
                        disabled={productSaved}
                        error={product.quantity < 1 || product.quantity === ''}
                        />
                    { !productSaved ? (
                    <Button edge="end" aria-label="Eliminar" onClick={() => handleDeleteProduct(index)} disabled={productSaved}>
                        <i className="material-icons-outlined delete-icon">delete</i>
                    </Button>
                    ) : (
                      null
                    )}
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
            </List>
          </div>
        ) : (
        <div className='text-product-container'>
            {productSaved ? (
            <Typography className='product-alert'>Debes añadir al menos un producto para continuar</Typography>
        ) : (
            <Typography>No hay productos añadidos aún.</Typography>
            )}
        </div>
        )}
      </div>
    </div>
  );
};

export default ProductList;
